import React, { useEffect, useState } from "react";
import api from "../services/api";
import { toast } from "react-toastify";
import "../styles/floatingForm.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";

const CreateUpdateMetatag = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  const editId = id;

  const [form, setForm] = useState({
    meta_url: "",
    meta_title: "",
    meta_description: "",
    packagediscription:"",
    h1tagedetails:"",
    meta_keyword:"",
    schema_data: "",
    ogtag_details: "",
  });

  const [errors, setErrors] = useState({});

  /** -----------------------------------
   * FETCH ONE META TAG (snake_case API)
   ----------------------------------- **/
  const fetchDetails = async () => {
    try {
      const res = await api.get(`/metatag/get/${editId}`);
      if (res.data.status === "success") {
        const d = res.data.data;

        // map snake_case -> camelCase-like fields
        setForm({
          meta_url: d.meta_url || "",
          meta_title: d.meta_title || "",
          meta_description: d.meta_description || "",
          packagediscription:d.packagediscription || "",
          h1tagedetails:d.h1tagedetails || "",
          meta_keyword:d.meta_keyword || "",
          schema_data: d.schema_data || "",
          ogtag_details: d.ogtag_details || "",
        });
      }
    } catch (error) {
      console.error("Failed to fetch meta tag", error);
    }
  };

  useEffect(() => {
    if (editId) fetchDetails();
  }, [editId]);

  /** -----------------------------------
   * VALIDATION
   ----------------------------------- **/
  const validate = () => {
    let e = {};
    if (!form.meta_url.trim()) e.meta_url = "Meta URL is required";
    if (!form.meta_title.trim()) e.meta_title = "Meta Title is required";
    if (!form.meta_description.trim())
      e.meta_description = "Meta Description is required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const closeForm = () => {
    navigate(-1);
  };

  /** -----------------------------------
   * SUBMIT HANDLER — camelCase API SEND
   ----------------------------------- **/
  const submitData = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    // convert UI state -> API required format
    const payload = {
      metaurl: form.meta_url,
      metatitle: form.meta_title,
      metadescription: form.meta_description,
      packagediscription:form.packagediscription,
      h1tagedetails:form.h1tagedetails,
      metakeyword:form.meta_keyword,
      schemadata: form.schema_data,
      ogtag_details: form.ogtag_details,
    };

    
    try {
      let res;

      if (editId) {
        res = await api.post(`/metatag/update/${editId}`, payload);
      } else {
        res = await api.post("/metatag/add", payload);
      }

      if (res.data.status === "success") {
        toast.success(`Metatag ${editId ? "updated" : "created"} successfully`);
        closeForm();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error saving meta tag");
      console.error(error);
    }
  };




  return (
    <div className="floating-form-container  "  >
      <div className="heading">
        <h2>{editId ? "Update Metatag" : "Create Metatag"}</h2>
      </div>

      <form onSubmit={submitData}>
        <div className="form-container overflow-y-scroll">
            <div className="section-1">
                <div className="input-container-floating-form wid-50">
                    <label>Meta URL *</label>
                    <input
                    type="text"
                    value={form.meta_url}
                    className={errors.meta_url ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, meta_url: e.target.value })
                    }
                    />
                    {errors.meta_url && (
                    <span className="text-danger small">{errors.meta_url}</span>
                    )}
                </div>

                <div className="input-container-floating-form wid-50">
                    <label>Meta Title *</label>
                    <input
                    type="text"
                    value={form.meta_title}
                    className={errors.meta_title ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, meta_title: e.target.value })
                    }
                    />
                    {errors.meta_title && (
                    <span className="text-danger small">{errors.meta_title}</span>
                    )}
                </div>

                

              

                <div className="input-container-floating-form wid-50">
                    <label>Meta Description *</label>
                    <input
                    type="text"
                    value={form.meta_description}
                    className={errors.meta_description ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, meta_description: e.target.value })
                    }
                    />
                    {errors.meta_description && (
                    <span className="text-danger small">{errors.meta_description}</span>
                    )}
                </div>

                <div className="input-container-floating-form wid-50">
                    <label>Page Description </label>
                    <input
                    type="text"
                    value={form.packagediscription}
                    className={errors.packagediscription ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, packagediscription: e.target.value })
                    }
                    />
                </div>

                <div className="input-container-floating-form wid-50">
                    <label>Page Title </label>
                    <input
                    type="text"
                    value={form.h1tagedetails}
                    className={errors.h1tagedetails ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, h1tagedetails: e.target.value })
                    }
                    />
                </div>

                <div className="input-container-floating-form wid-50">
                    <label>Keywords </label>
                    <input
                    type="text"
                    value={form.meta_keyword}
                    className={errors.meta_keyword ? "is-invalid" : ""}
                    onChange={(e) =>
                        setForm({ ...form, meta_keyword: e.target.value })
                    }
                    />
                </div>

                <div className="input-container-floating-form wid-100">
                  <label>Og Tag Details</label>

                    <textarea
                    rows={4}
                    value={form.ogtag_details}
                    onChange={(e) =>
                      setForm({ ...form, ogtag_details: e.target.value })
                    }
                    className={errors.ogtag_details ? "is-invalid" : ""}
                  />


                </div>

                <div className="input-container-floating-form wid-100">
                    <label>Schema Data</label>
                    <textarea
                    rows={4}
                    value={form.schema_data}
                    onChange={(e) =>
                        setForm({ ...form, schema_data: e.target.value })
                    }
                    />
                </div>
            </div>
        <div className="form-btn-container">
          <button type="submit">{editId ? "Update" : "Create"}</button>
          <button type="reset" onClick={closeForm}>Cancel</button>
        </div>
        </div>
      </form>
    </div>
  );
};

export default CreateUpdateMetatag;
